<template>
  <div>
    <v-container class="mt-10">
      <v-row class="justify-center">
        <v-col cols="6" v-show="loaded"
        >
            <pdf
                ref="pdfPreview"
                :src="`${apiUrl}pub/diplomas/${diplomaUUID}`"
            ></pdf>

<!--            <object style="height: 100%; width: 100%;" :data="`${apiUrl}pub/diplomas/${diplomaUUID}`" type="application/pdf">-->
<!--              <iframe  style="height: 100%; width: 100%;" :src="`https://docs.google.com/viewer?url=${apiUrl}pub/diplomas/${diplomaUUID}&embedded=true`" onload="loaded=true"></iframe>-->
<!--            </object>-->
        </v-col>

        <v-col cols="12" md="3" v-show="loaded">
          <!-- ispiši za desktop -->
          <v-btn
              color="primary"
              height="44"
              class="text-none mb-8 d-none d-sm-flex"
              depressed
              block
              @click="print()"
          >
            <v-icon class="mr-2">mdi-printer</v-icon>
            Ispiši
          </v-btn>
          <!-- preuzmi za mobitel -->
          <a
              :href="`${apiUrl}pub/diplomas/${diplomaUUID}`"
              class="d-flex d-sm-none"
              target="_blank"
          >
            <v-btn
                color="primary"
                height="44"
                class="text-none mb-8"
                depressed
                block
            >
              <v-icon class="mr-2">mdi-download</v-icon>
              Preuzmi
            </v-btn>
          </a>
          <!--        <ShareNetwork-->
          <!--          v-for="network in networks"-->
          <!--          :key="network.name"-->
          <!--          :network="network.name"-->
          <!--          title="SUMIT uvjerenje"-->
          <!--          :url="networkUrl"-->
          <!--          hashtags="SUMIT,uvjerenje"-->
          <!--          class="text-decoration-none"-->
          <!--        >-->
          <!--          <v-btn-->
          <!--            class="text-none justify-start white&#45;&#45;text mb-3"-->
          <!--            block-->
          <!--            height="44"-->
          <!--            depressed-->
          <!--            :style="`background-color: ${network.color}`"-->
          <!--          >-->
          <!--            <v-icon>-->
          <!--              {{ network.icon }}-->
          <!--            </v-icon>-->
          <!--            <v-divider class="mx-3 white" vertical />-->
          <!--            <span class="text-capitalize">-->
          <!--              {{ network.name }}-->
          <!--            </span>-->
          <!--          </v-btn>-->
          <!--        </ShareNetwork>-->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: {
    pdf,
  },

  data: function() {
    return {
      networkUrl: null,
      diplomaUUID: null,
      apiUrl: process.env.VUE_APP_SKOLE_API_URL,
      bufferValue: 20,
      loaded: true,
      bufferText: 'Kreiranje dokumenta..',
      interval: 0,
      networks: [
        {
          name: "facebook",
          icon: "mdi-facebook",
          color: "rgb(59, 89, 152)",
        },
        {
          name: "twitter",
          icon: "mdi-twitter",
          color: "rgb(0, 172, 237)",
        },
        {
          name: "whatsapp",
          icon: "mdi-whatsapp",
          color: "rgb(37, 211, 102);",
        },
        {
          name: "viber",
          icon: "mdi-phone-in-talk",
          color: "rgb(143, 93, 183)",
        },
      ],
    };
  },
  created() {
    document.title = "SUMIT matica - stranica za prijavu korisnika";
    this.diplomaUUID = this.$route.params.uvjerenje_id;
    this.networkUrl = window.location.href;
  },

  methods: {

    print() {
      this.$refs.pdfPreview.print();
    },
  },
};
</script>
